import { render } from "./StorefrontSessionGate.vue?vue&type=template&id=53f74509&scoped=true"
import script from "./StorefrontSessionGate.vue?vue&type=script&lang=js"
export * from "./StorefrontSessionGate.vue?vue&type=script&lang=js"

import "./StorefrontSessionGate.vue?vue&type=style&index=0&id=53f74509&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f74509"]])

export default __exports__